import React, { FC, ReactNode, useMemo } from 'react';
import cn from 'classnames';
import { ReactComponent as ErrorIcon } from '@blink/assets/src/icons/alertCircle.svg';
import { ReactComponent as SuccessIcon } from '@blink/assets/src/icons/checkCircleNotFilled.svg';
import { ReactComponent as AlertIcon } from '@blink/assets/src/icons/warningNotFilled.svg';

import { InfoCardTooltip } from './InfoCardTooltip';
import { useInfoCardStyle } from './InfoCard.style';

type InfoCardProps = {
    type: IconTypes;
    text: ReactNode;

    classes?: Partial<Record<InfoCardClasses, string>>;
};

export enum IconTypes {
    ALERT = 'alert',
    ERROR = 'error',
    INFO = 'info',
    SUCCESS = 'success',
}

type InfoCardClasses = 'root';

export const InfoCard: FC<InfoCardProps> = ({ type, text, classes }) => {
    const baseClasses = useInfoCardStyle();

    const icon = useMemo(() => {
        switch (type) {
            case IconTypes.SUCCESS:
                return <SuccessIcon />;
            case IconTypes.ERROR:
                return <ErrorIcon />;
            case IconTypes.ALERT:
                return <AlertIcon />;
            case IconTypes.INFO:
                return <InfoCardTooltip />;
        }
    }, [type]);

    return (
        <div className={cn(baseClasses.root, baseClasses[type], classes?.root || '')}>
            {icon}
            <div>{text}</div>
        </div>
    );
};
